import { lazy } from 'react';
import { Refine } from '@refinedev/core';
import routerBindings from '@refinedev/react-router-v6';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { dataProvider } from '@/api/dataProvider';
import { Shell } from '@/shell/Shell';

// As páginas carregam-se à medida que se navega. Importadas todas de uma vez,
// a consola servia um único ficheiro de 723 kB (214 kB comprimidos) só para
// mostrar o primeiro ecrã. O Suspense que as segura vive no Shell, para a
// navegação e o cabeçalho ficarem sempre visíveis enquanto uma página chega.
const OverviewPage = lazy(() => import('@/pages/OverviewPage').then((m) => ({ default: m.OverviewPage })));
const UsersPage = lazy(() => import('@/pages/UsersPage').then((m) => ({ default: m.UsersPage })));
const EventsPage = lazy(() => import('@/pages/EventsPage').then((m) => ({ default: m.EventsPage })));
const BiPage = lazy(() => import('@/pages/BiPage').then((m) => ({ default: m.BiPage })));
const SupportPage = lazy(() => import('@/pages/SupportPage').then((m) => ({ default: m.SupportPage })));
const StudioPage = lazy(() => import('@/pages/StudioPage').then((m) => ({ default: m.StudioPage })));
const UserDetailPage = lazy(() => import('@/pages/UserDetailPage').then((m) => ({ default: m.UserDetailPage })));
const OrgsPage = lazy(() => import('@/pages/OrgsPage').then((m) => ({ default: m.OrgsPage })));
const MarketplaceAdminPage = lazy(() => import('@/pages/MarketplaceAdminPage').then((m) => ({ default: m.MarketplaceAdminPage })));
const FiscalPage = lazy(() => import('@/pages/FiscalPage').then((m) => ({ default: m.FiscalPage })));
const AuditPage = lazy(() => import('@/pages/AuditPage').then((m) => ({ default: m.AuditPage })));
const PermissionsPage = lazy(() => import('@/pages/PermissionsPage').then((m) => ({ default: m.PermissionsPage })));

// Refine dá a espinha dorsal (data provider + resources + hooks de CRUD) sobre a
// nossa API /admin; a UI é a nossa (shell + MDS). As páginas "em breve" deixam de
// ser à mão — cada recurso novo é uma entrada aqui + um ecrã de lista.
export function App() {
  return (
    <BrowserRouter>
      <Refine
        dataProvider={dataProvider}
        routerProvider={routerBindings}
        resources={[
          { name: 'users', list: '/utilizadores', meta: { label: 'Utilizadores' } },
          { name: 'events', list: '/eventos', meta: { label: 'Eventos' } },
        ]}
        options={{ syncWithLocation: true, warnWhenUnsavedChanges: false, disableTelemetry: true }}
      >
        <Routes>
          <Route element={<Shell />}>
            <Route index element={<OverviewPage />} />
            <Route path="utilizadores" element={<UsersPage />} />
            <Route path="utilizadores/:id" element={<UserDetailPage />} />
            <Route path="organizacoes" element={<OrgsPage />} />
            <Route path="eventos" element={<EventsPage />} />
            <Route path="bi" element={<BiPage />} />
            <Route path="suporte" element={<SupportPage />} />
            <Route path="conteudos" element={<StudioPage />} />
            <Route path="marketplace" element={<MarketplaceAdminPage />} />
            <Route path="fiscal" element={<FiscalPage />} />
            <Route path="auditoria" element={<AuditPage />} />
            <Route path="permissoes" element={<PermissionsPage />} />
          </Route>
        </Routes>
      </Refine>
    </BrowserRouter>
  );
}
